import {Component, DestroyRef, inject, OnInit} from "@angular/core";
import {
  AangifteBerekening,
  BokkzIbDataService,
  IbRekenService,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
  filter,
  Observable,
  shareReplay,
  switchMap,
  take
} from "rxjs";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-overzicht-inkomen-box2',
    templateUrl: './overzicht-inkomen-box2.component.html',
    styleUrls: ['./overzicht-inkomen-box2.component.scss'],
    imports: [ReactiveFormsModule, SharedUiDetailsModule, SharedUiFormControlsModule, CommonModule],
})
export class OverzichtInkomenBox2Component implements OnInit {
    private dataService = inject(BokkzIbDataService);
    private destroyRef = inject(DestroyRef);
    private bokkzClient = inject(IbRekenService);
    public dataVisible$ = new BehaviorSubject<boolean>(false);
    public isDefAangifte = false;
    public isPartner = false;
    public isPartnerView = false;

    readonly incomeTaxEntity$: Observable<IncomeTaxEntity> = this.dataService.incomeTaxEntity$.pipe(
        filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
        takeUntilDestroyed(this.destroyRef),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    public formGroup = new FormGroup({
        inkomen: new FormControl<number | null>(0),
        persoonsgebondenAftrek: new FormControl<number | null>(0),
        belastbaarInkomen: new FormControl<number | null>(0),
        opbouwInkomen: new FormGroup({
            inkomenUitAanmerkelijkBelang: new FormControl<number | null>(0),
            verrekendVerlies: new FormControl<number | null>(0),
            saldoAanmerkelijkBelang: new FormControl<number | null>(0),
        }),
    });

    ngOnInit(): void {
        const berekening$ = this.incomeTaxEntity$.pipe(
            take(1),
            filter((data): data is IncomeTaxEntity => !!data.aangifte),
            switchMap((data) => {
                this.isDefAangifte = data.taxType === 'DA';
                this.isPartner = data.aangifte?.gezamenlijkeAangifte ?? false;
                return this.bokkzClient.getIncomeTaxCalculation(data.aangifte!);
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
            takeUntilDestroyed(this.destroyRef),
        );

        combineLatest([berekening$, this.dataService.partnerAangifte$.pipe(distinctUntilChanged())])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(([berekening, isPartner]) => {
                this.isPartnerView = isPartner; // ← toevoegen
                this.dataVisible$.next(false);
                this.resetAndPatchForms(isPartner ? (berekening.partnerBerekening ?? berekening) : berekening);
            });
    }

    private resetAndPatchForms(details: AangifteBerekening): void {
        this.formGroup.reset({}, { emitEvent: false });
        this.formGroup.patchValue(details.box2 ?? {}, { emitEvent: false });
        this.formGroup.disable({ emitEvent: false });
        this.dataVisible$.next(true);
    }
}
